<template>
  <div>
    <toast-alert
      v-if="isToast"
      :isLoading="getLoadingWatchlist"
      :text="status ? options.toast.title[0].success : options.toast.title[0].unsuccess"
      :status="status"
    ></toast-alert>
    <toast-confirmation v-if="isDialog" class="container">
      <h3 slot="header">{{options.dialog.title}}</h3>
      <div slot="body" class="confirm-body">{{options.dialog.body}} {{fundName}}</div>
      <a @click="confirmItem(true)" slot="confirm-yes" class="left">{{options.dialog.action[0].action1}}</a>
      <a @click="confirmItem(false)" slot="confirm-no" class="right">{{options.dialog.action[0].action2}}</a>
    </toast-confirmation>
    <toast-dialog :options="options" :action="action" v-if="showDialog">
      <template slot="button"></template>
    </toast-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex"
import ToastAlert from "../../../components/miniapp/global/ToastAlert.vue"
import ToastDialog from "../../../components/miniapp/global/ToastDialog"
import ToastConfirmation from "../../../components/miniapp/global/ToastConfirmation.vue"

export default {
  data() {
    return {
      isToast: false,
      isDialog: false,
      fadeStatus: false,
      showDialog: false
    }
  },
  props: {
    options: {
      type: Object
    },
    fundName: {
      type: String,
      default: ""
    },
    toastType: {
      type: String,
      default: ""
    },
    status: {
      type: Boolean,
      default: false
    },
    toggleToast: {
      type: Boolean,
      default: false
    },
    action: {
      type: Function
    }
  },
  computed: {
    ...mapGetters("watchlist", ["getLoadingWatchlist"])
  },
  mounted() {
    if (this.toastType == "alert") {
      this.generateAlert(this.toggleToast)
    } else if (this.toastType == "dialog") {
      this.showDialog = true
    } else {
      this.generateConfirm(this.toggleToast)
    }
  },
  methods: {
    generateAlert(bool) {
      if (bool) {
        this.isToast = true
        setTimeout(() => {
          this.$emit("close-toast", false)
        }, this.options.toast.duration * 1000)
      }
    },
    confirmItem(bool) {
      this.$emit("confirm-toast", bool)
    },
    generateConfirm(bool) {
      if (bool) {
        this.isDialog = true
      }
    }
  },
  components: {
    ToastAlert,
    ToastConfirmation,
    ToastDialog
  }
}
</script>

<style lang="scss" scoped>
.container {
  a {
    color: #d1d1d1;
  }
}
</style>